import styled from '@emotion/styled';
import {Divider, Grid, SvgIcon} from '@mui/material';
import backgroundImage from 'src/assets/images/white_lines_highres.jpg';
import bannerBackgroundImage from 'src/assets/images/background_redshift.jpg';
import transparentLogo from 'src/assets/images/original_on_transparent_logo.png';
import bytepadLogo from 'src/assets/images/widget_icon_w.reflection.svg';
import {APP} from 'src/styles/variables';

export const LoginWrapper = styled(Grid)`
  box-sizing: border-box;
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  // margin-top: 10vh;
  width: 100vw;
  background-image: url(${backgroundImage});
  background-repeat: no-repeat;
  background-size: 100% 100%;
`;

export const SignInGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  // width: 80%;
  // height: 80%;
  // max-width: 80%;
  border-radius: 15px;
  border: 0.125rem solid;
  border-color: ${APP.PALETTE.LOGIN.BORDER_COLOR};
  box-shadow:
    0 14px 28px ${APP.PALETTE.LOGIN.BOX_SHADOW_1},
    0 10px 10px ${APP.PALETTE.LOGIN.BOX_SHADOW_2};

  h1 {
    padding: 1.2rem;
  }

  h5 {
    margin: 0.4rem 0 2rem 0;
    cursor: pointer;
    text-decoration: underline;
  }

  /* h5:hover {
    text-decoration: underline;
  } */
`;

export const SignInForm = styled('form')`
  display: flex;
  flex-direction: column;
  padding-left: 3rem;
  padding-right: 3rem;
  width: 100%;
  height: 100%;
  gap: 1rem;

  @media (min-width: 400px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  @media (min-width: 600px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  @media (min-width: 900px) {
    padding-left: 3rem;
    padding-right: 3rem;
  }
`;

export const MessageSpan = styled('span')`
  margin: 0;
  padding: 0.3rem;
`;

export const SignUpGrid = styled(Grid)`
  background-color: lavender;
  height: inherit;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  h1 {
    padding: 1.2rem;
  }
`;

export const ForgetPasswordLink = styled(Grid)`
  margin: 0px 0px -2rem 0px;
  width: 100%;
  display: flex;
  justify-content: flex-end;

  h5 {
    font-weight: 300;
  }
  :hover {
    font-weight: 700;
  }
`;

export const LogoGrid = styled(Grid)`
  background-color: ${prop => prop.theme.palette.common.white};
  margin: 10px 25px;
  height: 20vh;
`;

export const LeftGrid = styled(Grid)`
  width: 55%;
  border-right: 0.125rem solid;
  border-color: ${APP.PALETTE.LOGIN.BORDER_COLOR};
  height: 100%;
  background-image: url(${bannerBackgroundImage});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-top-left-radius: 0.813rem;
  border-bottom-left-radius: 0.813rem;
  // overflow: hidden;
`;

export const LeftLogoGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  padding-top: 12.5rem;
  padding-left: 9.875rem;
  // max-width: 70%;
`;

export const RightGrid = styled(Grid)`
  // overflow: hidden;
  display: flex;
  // flex-wrap: nowrap;
  width: 45%;
  height: 100%;
  background-color: ${APP.PALETTE.COMMON.WHITE};
  border-top-right-radius: 0.813rem;
  border-bottom-right-radius: 0.813rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: column;
`;

export const RightHeaderLogoGrid = styled(Grid)`
  display: flex;
  background-image: url(${transparentLogo});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 9.375rem;
  width: 16.875rem;
  margin-top: 3.75rem;
  margin-bottom: 4.375rem;

  @media (min-width: 400px) {
    height: 7.125rem;
    width: 11.375rem;
  }

  @media (min-width: 600px) {
    height: 7.125rem;
    width: 11.375rem;
  }

  @media (min-width: 1000px) {
    height: 9.375rem;
    width: 16.875rem;
  }

  @media (min-width: 1000px) {
    height: 9.375rem;
    width: 16.875rem;
  }
`;

export const LeftSvgIconLogo = styled(SvgIcon)`
  // margin-top: 12.5rem;
  margin-left: 10.875rem;
  // height: 80%;
  // width: 100%;
  height: 450px;
  width: 600px;
  background-image: url(${bytepadLogo});
  background-repeat: no-repeat;
  background-size: contain;

  // @media (min-width: 600px) {
  //   // margin-top: 14.438rem;
  //   margin-left: 1.063rem;
  // }

  // @media (min-width: 1000px) {
  //   // margin-top: 14.438rem;
  //   margin-left: 1.063rem;
  // }

  // @media (min-width: 1600px) {
  //   // margin-top: 14.438rem;
  //   margin-left: 24.9rem;
  // }
`;

export const ButtonsSectionGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const LoginButtonGrid = styled(Grid)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoginWithAzureGrid = styled(Grid)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 1.5rem;
`;

export const TextDivider = styled(Divider)`
  padding-top: 1.5rem;
  color: ${APP.PALETTE.LOGIN.GRAY};
`;

export const CircularProgressDiv = styled('div')<{height?: string}>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${props => props?.height ?? '80vh'};
`;
